import "@material-dev/insights-portal-ui-components/lib/styles/variables.css";
import "@material-dev/insights-portal-ui-components/lib/styles/fonts.css";

import { MRequiredAuth, userSelector, FeatureFlagProvider } from "@material-dev/insights-portal-ui-components/lib";
import initExtenstions from "@material-dev/insights-portal-ui-components/lib/extenstions/initExtenstions";
import MApp from "@material-dev/insights-portal-ui-components/lib/feature-components/m-app/MApp";
import useAuth from "@material-dev/insights-portal-ui-components/lib/hooks/useAuth";
import { UserIdentity } from "@material-dev/insights-portal-ui-components/lib/slices/user/model/UserIdentity";
import React, { useLayoutEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import AppHeader from "components/AppHeader";
import { APP_NAME } from "const/config";

import useEncodingApiErrorListener from "../hooks/useEncodingApiErrorListener";
import { AppRoutes } from "./routes";
import { EmailNotificationClient, IEmailNotificationClient } from "./SharedApiClient";
import ThemeProvider from "./ThemeProvider";

initExtenstions();

const emailNotificationClient: IEmailNotificationClient = new EmailNotificationClient(
  process.env.REACT_APP_SHARED_API_URL,
);
const { REACT_APP_ROLE_NAME } = process.env;
const roles = REACT_APP_ROLE_NAME ? [REACT_APP_ROLE_NAME] : ["datamanager", "DataManager"];

const App: React.FC = () => {
  const { currentUser } = useSelector(userSelector);
  useAuth();
  useEncodingApiErrorListener();
  const headerComponent = useMemo(() => <AppHeader />, []);

  useLayoutEffect(() => {
    // TODO: temporary solution for iFrame layer
    if (process.env.REACT_APP_ENV === "Development") {
      setTimeout(() => {
        const frame = document.querySelector("iframe");
        frame?.parentNode?.removeChild(frame);
      }, 100);
    }
  });

  if (!currentUser) {
    return null;
  }

  const onAuthorizeError = async (user: UserIdentity, _: string, cookies: string[]) => {
    try {
      await emailNotificationClient.sendAccessDeniedNotification({
        appName: APP_NAME,
        cookies,
        userEmail: user.username,
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <MRequiredAuth roles={roles} appName={APP_NAME} onAuthorizeError={onAuthorizeError}>
      <FeatureFlagProvider>
        <ThemeProvider>
          <MApp
            routes={AppRoutes}
            navigation={[]}
            customNavMenuComponent={headerComponent}
            applicationName="Data Manager"
            applicationUrl="/"
          />
        </ThemeProvider>
      </FeatureFlagProvider>
    </MRequiredAuth>
  );
};

export default App;
